import { render, staticRenderFns } from "./financeApproval.vue?vue&type=template&id=4b6ee5e1&scoped=true&"
import script from "./financeApproval.vue?vue&type=script&lang=js&"
export * from "./financeApproval.vue?vue&type=script&lang=js&"
import style0 from "./financeApproval.vue?vue&type=style&index=0&id=4b6ee5e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6ee5e1",
  null
  
)

export default component.exports